// extracted by mini-css-extract-plugin
var _1 = "XTZ0o";
var _2 = "IkPJt";
var _3 = "q6xwj";
var _4 = "vU1Iw";
var _5 = "pn7Ba";
var _6 = "uKhWS";
var _7 = "lnytX";
var _8 = "QjZlO";
var _9 = "OtB2U";
export { _1 as "icon-button", _2 as "is-disabled", _3 as "is-large", _4 as "is-medium", _5 as "is-processing", _6 as "is-regular", _7 as "is-selected", _8 as "is-small", _9 as "spinner" }
